import { useState } from "react"
import {huns} from "../../../../data/huns"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"
const Huns =(props) => {

    const selectList = huns.map(hun => ({
        id:hun.id,
        name:hun.name,
        wood:hun.wood,
        clay:hun.clay,
        iron:hun.iron,
        crop:hun.crop,
        all: hun.wood + hun.clay + hun.crop + hun.iron
    }) )

    
    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    } 

    function vypis() {
        const selectedHun = selectList[selectValue-1]
        props.addItem(selectedHun)
    }

return (

    <div>
        <ListSelect label="...choose trop..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
    </div>
    

)

}
export default Huns